export const gptUrl = 'https://www.googletagservices.com/tag/js/gpt.js';

export const ENABLER_KEY_SB_ADS = 'SB_ADS';
export const BANNER_ADS_AB_TEST = 'BannerAds' as const;

export const TILE_AD_KEY = 'productTile';
export const BILLBOARD_AD_KEY = 'billboard';

export const PRODUCT_TILE_WIDTH = 331 as const;
export const PRODUCT_TILE_HEIGHT = 419 as const;
export const PRODUCT_TILE_WIDTH_V2 = 300 as const;
export const PRODUCT_TILE_HEIGHT_V2 = 250 as const;
export const BILLBOARD_DESKTOP_WIDTH = 970 as const;
export const BILLBOARD_DESKTOP_HEIGHT = 250 as const;
export const BILLBOARD_TABLET_WIDTH = 746 as const;
export const BILLBOARD_TABLET_HEIGHT = 192 as const;
export const BILLBOARD_MOBILE_WIDTH = 320 as const;
export const BILLBOARD_MOBILE_HEIGHT = 82 as const;

export const BILLBOARD_MOBILE_HEIGHT_V2 = 100 as const;
export const BILLBOARD_TABLET_WIDTH_V2 = 728 as const;
export const BILLBOARD_TABLET_HEIGHT_V2 = 90 as const;

export const ELEMENT_ID_BILLBOARD = 'ad-billboard';
export const ELEMENT_ID_BILLBOARD_MOBILE = 'ad-billboard-mobile';
export const ELEMENT_ID_BILLBOARD_TABLET = 'ad-billboard-tablet';
export const ELEMENT_ID_PRODUCT_TILE_AD_PREFIX = 'tile-ad';

export const HOLIDAY_COLLECTION_SEGMENT = 'holiday-gift-guide' as const;

export const HOME_TOP_BILLBOARD_PLACEMENT = 'home-top' as const;
export const HOME_BOTTOM_BILLBOARD_PLACEMENT = 'home-bottom' as const;
export const ORDER_CONFIRMATION_BILLBOARD_PLACEMENT = 'order-confirmation' as const;
export const PDP_AVAILABLE_TOP_BILLBOARD_PLACEMENT = 'pdp-available-top' as const;
export const PDP_AVAILABLE_BOTTOM_BILLBOARD_PLACEMENT = 'pdp-available-bottom' as const;
export const PDP_SOLD_TOP_BILLBOARD_PLACEMENT = 'pdp-sold-top' as const;
export const PDP_SOLD_BOTTOM_BILLBOARD_PLACEMENT = 'pdp-sold-bottom' as const;
export const PDP_CONDENSED_TOP_BILLBOARD_PLACEMENT = 'pdp-condensed-top' as const;
export const PDP_CONDENSED_BOTTOM_BILLBOARD_PLACEMENT = 'pdp-condensed-bottom' as const;
